export const Embeds = [
    {
        type: 'html',
        title: 'HTML Embed',
        getConfiguration: (context) => null,
        condition: (context) => ('name' in context ? context.name : context.localName) == 'embed',
        isRenderable: false
    },
    {
        type: 'form',
        title: 'Sitecore Form',
        getConfiguration: (context) => { var _a; return context.getAttribute('data-embed-title') || ((_a = context.getAttribute('data-external-id')) === null || _a === void 0 ? void 0 : _a.includes('formId')) || null; },
        condition: (context) => String(context.getAttribute('class')).includes('-component--form') ||
            context.getAttribute('data-embed-type') == 'form',
        isRenderable: false
    },
    {
        type: 'feaas',
        title: 'Sitecore component',
        getConfiguration: (context) => context.getAttribute('library') && context.getAttribute('component') ? true : false,
        condition: (context) => context.getAttribute('data-embed-as') == 'feaas-component' || context.getAttribute('data-embed-type') == 'feaas',
        isRenderable: true
    },
    {
        type: 'web',
        title: 'Web component',
        getConfiguration: (context) => context.getAttribute('data-embed-as'),
        condition: (context) => context.getAttribute('data-embed-as') && context.getAttribute('data-embed-as') != 'feaas-external',
        isRenderable: true
    },
    {
        type: 'byoc',
        title: 'Component',
        getConfiguration: (context) => context.getAttribute('data-embed-title') || context.getAttribute('data-external-id'),
        condition: (context) => ['embed', 'component'].includes('name' in context ? context.name : context.localName),
        isRenderable: false
    }
];
export function getEmbedDefinition(context) {
    return Embeds.find((e) => e.condition(context));
}
//# sourceMappingURL=embed.js.map